/*
 * File: /src/stores/shop-globals-edit.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 20th July 2018 2:20:53 pm
 * Last Modified: Tuesday, 21st August 2018 11:13:59 am
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
import { StoreDefaultMetafieldsHelper } from '@/helpers'

const initialState = () => ({
    scope: 'globals',
    id: 0
})

const state = StoreDefaultMetafieldsHelper.buildState({ 
    state: initialState()
})


const actions = StoreDefaultMetafieldsHelper.buildActions({
    actions: {}
})

const mutations = StoreDefaultMetafieldsHelper.buildMutations({
    mutations: {}
})

const getters = StoreDefaultMetafieldsHelper.buildGetters({
    getters: {}
})

export default {
    namespaced: true,
    state, actions, mutations, getters
}


// WEBPACK FOOTER //
// ./src/stores/shop-globals-edit.js